import { createContext } from 'react';

import { IDefaultShopConfig, IShopConfig } from '@/store/ducks/shopConfig/types';

import { IOrder } from '../../../store/ducks/order/types';
import { ISettingConfig } from '../../../store/ducks/settings/types';

export interface IWebContext {
  order: IOrder | null;
  selectBase64: string;
  configs: ISettingConfig;
  consentGiven: boolean;
  menuOpen: boolean;
  privacyPolicy: string | null;
  shop: IShopConfig;
  defaultShop: IDefaultShopConfig;
  min_order_amount: number;
  webapp_out_of_delivery: boolean;
  setMenuOpen: (open: boolean) => void;
  setShowCartAlertModal: (show: boolean) => void;
  setShowCPFModal: (show: boolean) => void;
  setShowIsCartBlockedModal: (show: boolean) => void;
  setShowIdenfificationModal: (show: boolean) => void;
  setWebappOutOfDelivery: (outOfDelivery: boolean) => void;
  setMinOrderAmount: (amount: number) => void;
}

export const WebContext = createContext<IWebContext | null>(null);
